import React, { useState, useEffect } from 'react';
import {
  Button,
  Container,
  Box,
  Modal,
  Paper,
  TextField,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

const EditClientDetails = () => {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [clientId, setClientId] = useState('');
  const [clientCode, setClientCode] = useState('');
  const [clientName, setClientName] = useState('');
  const [clientNameArabic, setClientNameArabic] = useState('');
  const [mobileNo, setMobileNo] = useState('');
  const [email, setEmail] = useState('');
  const [trnNo, setTrnNo] = useState('');
  const [country, setCountry] = useState('');
  const [state, setState] = useState('');
  const [city, setCity] = useState('');
  const [poBox, setPoBox] = useState('');
  const [address, setAddress] = useState('');
  const [description, setDescription] = useState('');

  const navigate = useNavigate();

  const staticClientData = [
    { clientId: 1, clientCode: 'C001', clientName: 'John Doe', mobileNumber: '1234567890', email: 'john.doe@example.com', trnNo: 'TRN123456', country: 'USA', state: 'California', city: 'Los Angeles', poBox: '12345', address: '123 Main St', description: 'Sample Description 1' },
    { clientId: 2, clientCode: 'C002', clientName: 'Jane Smith', mobileNumber: '9876543210', email: 'jane.smith@example.com', trnNo: 'TRN987654', country: 'Canada', state: 'Ontario', city: 'Toronto', poBox: '67890', address: '456 Elm St', description: 'Sample Description 2' },
    { clientId: 3, clientCode: 'C003', clientName: 'Alice Johnson', mobileNumber: '5551234567', email: 'alice.j@example.com', trnNo: 'TRN555123', country: 'UK', state: 'England', city: 'London', poBox: '54321', address: '789 Oak St', description: 'Sample Description 3' },
    { clientId: 4, clientCode: 'C004', clientName: 'Bob Brown', mobileNumber: '4449876543', email: 'bob.brown@example.com', trnNo: 'TRN444987', country: 'Australia', state: 'New South Wales', city: 'Sydney', poBox: '09876', address: '321 Pine St', description: 'Sample Description 4' },
    { clientId: 5, clientCode: 'C005', clientName: 'Charlie Davis', mobileNumber: '7776665555', email: 'charlie.d@example.com', trnNo: 'TRN777666', country: 'Germany', state: 'Bavaria', city: 'Munich', poBox: '56789', address: '654 Cedar St', description: 'Sample Description 5' },
    { clientId: 6, clientCode: 'C006', clientName: 'Diana Evans', mobileNumber: '3332221111', email: 'diana.e@example.com', trnNo: 'TRN333222', country: 'USA', state: 'Texas', city: 'Houston', poBox: '11223', address: '987 Birch St', description: 'Sample Description 6' },
  ];

  const staticCountryData = [
    { countryId: 1, countryName: 'USA' },
    { countryId: 2, countryName: 'Canada' },
    { countryId: 3, countryName: 'UK' },
    { countryId: 4, countryName: 'Australia' },
    { countryId: 5, countryName: 'Germany' },
  ];

  const staticStateData = {
    'USA': ['California', 'Texas', 'Florida', 'New York'],
    'Canada': ['Ontario', 'Quebec', 'British Columbia', 'Alberta'],
    'UK': ['England', 'Scotland', 'Wales', 'Northern Ireland'],
    'Australia': ['New South Wales', 'Victoria', 'Queensland', 'Western Australia'],
    'Germany': ['Bavaria', 'Hesse', 'Berlin', 'Hamburg'],
  };

  const staticCityData = {
    'USA': {
      'California': ['Los Angeles', 'San Francisco', 'San Diego'],
      'Texas': ['Houston', 'Dallas', 'Austin'],
      'Florida': ['Miami', 'Orlando', 'Tampa'],
      'New York': ['New York City', 'Buffalo', 'Rochester'],
    },
    'Canada': {
      'Ontario': ['Toronto', 'Ottawa', 'Mississauga'],
      'Quebec': ['Montreal', 'Quebec City', 'Laval'],
      'British Columbia': ['Vancouver', 'Victoria', 'Kelowna'],
      'Alberta': ['Calgary', 'Edmonton', 'Red Deer'],
    },
    'UK': {
      'England': ['London', 'Manchester', 'Birmingham'],
      'Scotland': ['Edinburgh', 'Glasgow', 'Aberdeen'],
      'Wales': ['Cardiff', 'Swansea', 'Newport'],
      'Northern Ireland': ['Belfast', 'Derry', 'Lisburn'],
    },
    'Australia': {
      'New South Wales': ['Sydney', 'Newcastle', 'Wollongong'],
      'Victoria': ['Melbourne', 'Geelong', 'Ballarat'],
      'Queensland': ['Brisbane', 'Gold Coast', 'Sunshine Coast'],
      'Western Australia': ['Perth', 'Mandurah', 'Bunbury'],
    },
    'Germany': {
      'Bavaria': ['Munich', 'Nuremberg', 'Augsburg'],
      'Hesse': ['Frankfurt', 'Wiesbaden', 'Darmstadt'],
      'Berlin': ['Berlin', 'Potsdam', 'Brandenburg'],
      'Hamburg': ['Hamburg', 'Altona', 'Harburg'],
    },
  };

  useEffect(() => {
    // Auto-fill the form with the first client's data by default
    if (staticClientData.length > 0) {
      const firstClient = staticClientData[0];
      setClientId(firstClient.clientId);
      setClientCode(firstClient.clientCode);
      setClientName(firstClient.clientName);
      setMobileNo(firstClient.mobileNumber);
      setEmail(firstClient.email);
      setTrnNo(firstClient.trnNo);
      setCountry(firstClient.country);
      setState(firstClient.state);
      setCity(firstClient.city);
      setPoBox(firstClient.poBox);
      setAddress(firstClient.address);
      setDescription(firstClient.description);
    }
  }, []);

  const handleSave = (e) => {
    e.preventDefault();
    if (clientCode && clientName && mobileNo && email && trnNo && country && state && city && poBox && address && description) {
      setShowSuccessModal(true);
    } else {
      alert('Please fill all fields');
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  const handleClientChange = (e) => {
    const selectedClientId = e.target.value;
    const selectedClient = staticClientData.find(client => client.clientId === parseInt(selectedClientId));
    if (selectedClient) {
      setClientId(selectedClient.clientId);
      setClientCode(selectedClient.clientCode);
      setClientName(selectedClient.clientName);
      setMobileNo(selectedClient.mobileNumber);
      setEmail(selectedClient.email);
      setTrnNo(selectedClient.trnNo);
      setCountry(selectedClient.country);
      setState(selectedClient.state);
      setCity(selectedClient.city);
      setPoBox(selectedClient.poBox);
      setAddress(selectedClient.address);
      setDescription(selectedClient.description);
    }
  };

  return (
    <Container>
      <Box
        sx={{
          backgroundColor: 'rgba(2, 78, 101, 1)',
          padding: '12px 16px',
          boxShadow: 3,
          borderRadius: '4px 4px 0 0',
          margin: '0 auto',
          width: "100%",
        }}
      >
        <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
          Edit Client Details
        </Typography>
      </Box>
      <Paper elevation={3} style={{ padding: 16, width: '100%', margin: 'auto', marginTop: 6, backgroundColor: '#f8fdfeff' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <FormControl fullWidth sx={{ my: 2 }}>
            <InputLabel id="client-label">Client</InputLabel>
            <Select
              labelId="client-label"
              id="client"
              value={clientId}
              label="Client"
              onChange={handleClientChange}
            >
              {staticClientData.map((client) => (
                <MenuItem key={client.clientId} value={client.clientId}>
                  {client.clientName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <TextField
              label="Client Code"
              variant="outlined"
              fullWidth
              value={clientCode}
              onChange={(e) => setClientCode(e.target.value)}
            />
            <TextField
              label="Client Name"
              variant="outlined"
              fullWidth
              value={clientName}
              onChange={(e) => setClientName(e.target.value)}
            />
          </Box>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <TextField
              label="Client Name (Arabic)"
              variant="outlined"
              fullWidth
              value={clientNameArabic}
              onChange={(e) => setClientNameArabic(e.target.value)}
            />
            <TextField
              label="Mobile No."
              variant="outlined"
              fullWidth
              value={mobileNo}
              onChange={(e) => setMobileNo(e.target.value)}
            />
          </Box>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <TextField
              label="Email"
              variant="outlined"
              fullWidth
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <TextField
              label="TRN No."
              variant="outlined"
              fullWidth
              value={trnNo}
              onChange={(e) => setTrnNo(e.target.value)}
            />
          </Box>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <FormControl fullWidth>
              <InputLabel id="country-label">Country</InputLabel>
              <Select
                labelId="country-label"
                id="country"
                value={country}
                label="Country"
                onChange={(e) => {
                  setCountry(e.target.value);
                  setState('');
                  setCity('');
                }}
              >
                {staticCountryData.map((country) => (
                  <MenuItem key={country.countryId} value={country.countryName}>
                    {country.countryName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl fullWidth>
              <InputLabel id="state-label">State</InputLabel>
              <Select
                labelId="state-label"
                id="state"
                value={state}
                label="State"
                onChange={(e) => {
                  setState(e.target.value);
                  setCity('');
                }}
                disabled={!country}
              >
                {country && staticStateData[country]?.map((stateItem) => (
                  <MenuItem key={stateItem} value={stateItem}>
                    {stateItem}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <FormControl fullWidth>
              <InputLabel id="city-label">City</InputLabel>
              <Select
                labelId="city-label"
                id="city"
                value={city}
                label="City"
                onChange={(e) => setCity(e.target.value)}
                disabled={!state}
              >
                {state && country && staticCityData[country]?.[state]?.map((cityItem) => (
                  <MenuItem key={cityItem} value={cityItem}>
                    {cityItem}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              label="PO Box"
              variant="outlined"
              fullWidth
              value={poBox}
              onChange={(e) => setPoBox(e.target.value)}
            />
          </Box>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <TextField
              label="Address"
              variant="outlined"
              fullWidth
              multiline
              rows={4}
              value={address}
              onChange={(e) => setAddress(e.target.value)}
            />
            <TextField
              label="Description"
              variant="outlined"
              fullWidth
              multiline
              rows={4}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2, gap: 2 }}>
            <Button
              variant="contained"
              sx={{
                backgroundColor: '#127498ff',
                '&:hover': { backgroundColor: '#116280ff' },
              }}
              onClick={handleSave}
            >
              UPDATE
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={handleCancel}
            >
              CANCEL
            </Button>
          </Box>
        </Box>
      </Paper>
      <Modal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        aria-labelledby="success-modal-title"
        aria-describedby="success-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
            <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Client Updated ✅
            </Typography>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Typography id="success-modal-description" sx={{ mb: 2 }}>
              Client Updated Successfully
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setShowSuccessModal(false);
                  navigate(-1);
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Container>
  );
};

export default EditClientDetails;
